import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LinkComponent } from '../../atoms/link/link.component';
import LinkType from '../../../shared/enums/link-type.enums';
import { Colors, Sizes } from '../../../shared/enums/shared.enums';

import { IconComponent } from '../../atoms/icon/icon.component';

import { Link } from '../../../shared/interfaces/link.interface';
import { CapitalizePipe } from '../../capitalize.pipe';

@Component({
  selector: 'hdi-distractor',
  standalone: true,
  imports: [CommonModule, LinkComponent, IconComponent, CapitalizePipe],
  templateUrl: './distractor.component.html',
  styleUrl: './distractor.component.scss',
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class DistractorComponent {
  @Input() link?: Link;
  @Input() circleText?: string;
  @Input() circleSplash?: string;
  @Input() circleIcon?: string;
  @Input() rotationDegrees?: number = -12;
  @Input() text?: string;

  @Input() iconColor: Colors = Colors.LIGHT_BLUE;
  LinkType = LinkType;
  Colors = Colors;
  Sizes = Sizes;
}
